var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-chart',{attrs:{"type":"line","labels":_vm.labels,"datasets":_vm.datasets,"width":"400","height":"100","options":{
    scales: {
      xAxes: [{
        gridLines: {
          drawOnChartArea: false
        }
      }]
    }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }